import React, { useState } from "react";
import Card from "../../MyUI/Card/Card";
import EditableForm from "../../MyUI/EditableForm/EditableForm";
import { forgottenPassword } from '../../../services/services';
import countryCodes from "../../../assets/files/country_codes.json";

export default function ForgottenPassword() {
  const formFields=[
    {key: "email", label: "Email", type: "email", validation: ["required", "email"] },
  ];

  const [formParams, setFormParams] = useState([{}]);
    
  const idField = "id";
  const services= {
      create: forgottenPassword,
      services_url_names: {
      create: "forgottenPassword",
      },
    }
  
  return (
    <Card title={"Password Reset"} showChevron={false}>
       <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center", 
          }}
        >
        <h2 style={{marginBottom: "50px"}}>Password Reset</h2>
        {/* EditableForm rendered directly (NO Dialog) */}
        <EditableForm
          params={formParams}
          setParams={setFormParams}
          state="create"
          title={"ForgottenPassword"}
          columns={formFields}
          saveButtonName={"Send Verification Email"}
          services={services}       
          idField={idField}         
          refParam={null}   
          onClose={() => {window.location.href = "/ConnectionPopUp"}}
          onSaved={(f) => {}}
        />

      </div>
    </Card>
  );
}
